module.exports = __webpack_public_path__ + "static/media/banner1.5d0f1cbc.png";